import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { appService } from "../../App/app.service";
import Skeleton from "@material-ui/lab/Skeleton";
import { styles } from "../NewFunnel/FunnelStyles";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
import ForecastRollupHeader from "./ForecastRollupHeader";

const useStyles = makeStyles((theme) => ({
  ...styles,
  root: {
    width: "100%",
    margin: 0,
    padding: theme.spacing(2),
  },
  section: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  cardSkeleton: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
  },
  centerButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "& h2": {
      fontWeight: 600,
    },
  },
  dialogContent: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  dialogActions: {
    padding: theme.spacing(2),
    justifyContent: "center",
  },
  cancelButton: {
    marginRight: theme.spacing(2),
  },
}));

const ForecastRollup = (props) => {
  const classes = useStyles();

  const [state, setState] = useState({
    judgementValues: {},
    opportunities: [],
    originalOpportunities: [], // Store original state
    originalJudgementValues: {}, // Store original judgement values
  });

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [hasSubmittedSuccessfully, setHasSubmittedSuccessfully] = useState(false);

  // Check if user is a manager
  const isManager = props.forecastRollupData?.role === "manager";

  useEffect(() => {
    props.getForecastRollupData(props.company);
  }, []);

  useEffect(() => {
    if (
      props.forecastRollupData &&
      props.forecastRollupData.opportunities &&
      props.forecastRollupData.opportunities.length > 0
    ) {
     let initialJudgements = {};
    
    if (props.forecastRollupData.judgementValues) {
      // Use judgement values from backend
      initialJudgements = { ...props.forecastRollupData.judgementValues };
    } else if (props.forecastRollupData.includeForForecastRollup) {
      // Fallback: initialize to 0 if no backend values
      props.forecastRollupData.includeForForecastRollup.forEach((category) => {
        initialJudgements[category] = 0;
      });
    }

      // Initialize opportunities with manager override fields
      const opportunitiesWithOverrides = props.forecastRollupData.opportunities.map(opp => ({
        ...opp,
        Manager_Override_ACV: opp.Manager_Override_ACV || "",
        Manager_Override_Forecast_Category: opp.Manager_Override_Forecast_Category || "-",
        
      }));

    setState((prev) => ({
        ...prev,
        opportunities: opportunitiesWithOverrides,
        originalOpportunities: JSON.parse(JSON.stringify(opportunitiesWithOverrides)), // Deep copy
        judgementValues: initialJudgements,
        originalJudgementValues: JSON.parse(JSON.stringify(initialJudgements)), // Deep copy
      }));

      // Reset submission flag when new data loads
      setHasSubmittedSuccessfully(false);
    }
  }, [props.forecastRollupData]);

  // Watch for successful submission
  useEffect(() => {
    if (props.submitSuccess && !props.submittingForecast) {
      // Submission was successful
      setHasSubmittedSuccessfully(true);
      
      // Update original values to current values (so changes are now the baseline)
      setState((prev) => ({
        ...prev,
        originalOpportunities: JSON.parse(JSON.stringify(prev.opportunities)),
        originalJudgementValues: JSON.parse(JSON.stringify(prev.judgementValues)),
      }));
    }
  }, [props.submitSuccess, props.submittingForecast]);

  const formatWeekEndingDate = (dateString) => {
  if (!dateString) return "N/A";

  // 🔹 Handle both "YYYY-MM-DD" and full ISO strings by ignoring time part
  const pureDateString = dateString.split("T")[0]; // e.g. "2025-10-10"

  // 🔹 Create date without timezone shift
  const [year, month, day] = pureDateString.split("-").map(Number);
  const date = new Date(year, month - 1, day); // JS month is 0-based

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};



  const handleOpenConfirmModal = () => {
    setConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const handleConfirmSubmit = () => {
    setConfirmModalOpen(false);
    submitForecast();
  };

//   const getChangedOpportunities = () => {
//     const changedOpps = [];

//     state.opportunities.forEach((currentOpp, index) => {
//       const originalOpp = state.originalOpportunities[index];
      
//       if (!originalOpp) return;

//       let hasChanged = false;

//       if (isManager) {
//         // For managers: check if forecast category OR manager overrides changed
//         const forecastCategoryChanged = 
//           currentOpp.Forecast_Category !== originalOpp.Forecast_Category ||
//           currentOpp.Forecast_Category_Name !== originalOpp.Forecast_Category_Name;

//         const managerACVChanged = 
//           currentOpp.Manager_Override_ACV !== originalOpp.Manager_Override_ACV;

//         const managerCategoryChanged = 
//           currentOpp.Manager_Override_Forecast_Category !== originalOpp.Manager_Override_Forecast_Category;

//         hasChanged = forecastCategoryChanged || managerACVChanged || managerCategoryChanged;
//       } else {
//         // For reps: only check if forecast category changed
//         hasChanged = 
//           currentOpp.Forecast_Category !== originalOpp.Forecast_Category ||
//           currentOpp.Forecast_Category_Name !== originalOpp.Forecast_Category_Name;
//       }

//       if (hasChanged) {
//         changedOpps.push(currentOpp);
//       }
//     });

//     return changedOpps;
//   };

const getChangedOpportunities = () => {
  const changedOpps = [];

  state.opportunities.forEach((currentOpp) => {
    const originalOpp = state.originalOpportunities.find(
      (opp) => opp.Opp_ID === currentOpp.Opp_ID
    );

    if (!originalOpp) return;

    let hasChanged = false;

    if (isManager) {
      const forecastCategoryChanged =
        currentOpp.Forecast_Category !== originalOpp.Forecast_Category ||
        currentOpp.Forecast_Category_Name !== originalOpp.Forecast_Category_Name;

      const managerACVChanged =
        currentOpp.Manager_Override_ACV !== originalOpp.Manager_Override_ACV;

      const managerCategoryChanged =
        currentOpp.Manager_Override_Forecast_Category !==
        originalOpp.Manager_Override_Forecast_Category;

      hasChanged =
        forecastCategoryChanged || managerACVChanged || managerCategoryChanged;
    } else {
      hasChanged =
        currentOpp.Forecast_Category !== originalOpp.Forecast_Category ||
        currentOpp.Forecast_Category_Name !== originalOpp.Forecast_Category_Name;
    }

    if (hasChanged) {
      changedOpps.push(currentOpp);
    }
  });

  return changedOpps;
};

  const hasJudgementChanged = () => {
    const categories = Object.keys(state.judgementValues);
    
    for (let category of categories) {
      const currentValue = parseFloat(state.judgementValues[category]) || 0;
      const originalValue = parseFloat(state.originalJudgementValues[category]) || 0;
      
      if (currentValue !== originalValue) {
        return true;
      }
    }
    
    return false;
  };

  const hasAnyChanges = () => {
    const changedOpportunities = getChangedOpportunities();
    const judgementChanged = hasJudgementChanged();
    
    return changedOpportunities.length > 0 || judgementChanged;
  };

//   const submitForecast = () => {
//     const changedOpportunities = getChangedOpportunities();

//     const submissionData = {
//         f1ACV : totals[props.forecastRollupData.includeForForecastRollup[0]] || 0,
//         f2ACV: totals[props.forecastRollupData.includeForForecastRollup[1]] || 0,
//       weekEnding: props.forecastRollupData?.week_ending?.[0],
//       userId: props.userId,
//       userName: props.forecastRollupData?.name,
//       role: props.forecastRollupData?.role,
//       submitterHierarchyPosition: isManager ? "Manager" : "Rep",
//       judgementValues: state.judgementValues,
//       opportunities: changedOpportunities.map((opp) => ({
//         Opp_ID: opp.Opp_ID,
//         OppName: opp.OppName,
//         Team: opp.Team,
//         Owner_Name: opp.Owner_Name,
//         Stage: opp.Stage,
//         ACV: opp.ACV,
//         Projected_Close_Date: opp.Projected_Close_Date,
//         Forecast_Category: opp.Forecast_Category,
//         Forecast_Category_Name: opp.Forecast_Category_Name,
//         ...(isManager && {
//           Manager_Override_ACV: opp.Manager_Override_ACV,
//           Manager_Override_Forecast_Category: opp.Manager_Override_Forecast_Category,
//         }),
//       })),
//     };

//     console.log("Submitting opportunities:", changedOpportunities.length, "out of", state.opportunities.length);
//     console.log("Judgement changed:", hasJudgementChanged());

//     props.submitForecast(submissionData);
//   };

const submitForecast = () => {
  const changedOpportunities = getChangedOpportunities();
  const { repTotals, managerTotals } = calculateTotals();
  
  // Use manager totals for submission if manager, otherwise use rep totals
  const totalsToSubmit = isManager ? managerTotals : repTotals;

  const submissionData = {
    f1ACV: totalsToSubmit[props.forecastRollupData.includeForForecastRollup[0]] || 0,
    f2ACV: totalsToSubmit[props.forecastRollupData.includeForForecastRollup[1]] || 0,
    weekEnding: props.forecastRollupData?.week_ending?.[0],
    userId: props.userId,
    userName: props.forecastRollupData?.name,
    role: props.forecastRollupData?.role,
    submitterHierarchyPosition: isManager ? "Manager" : "Rep",
    judgementValues: state.judgementValues,
    opportunities: changedOpportunities.map((opp) => ({
      Opp_ID: opp.Opp_ID,
      OppName: opp.OppName,
      Team: opp.Team,
      Owner_Name: opp.Owner_Name,
      Stage: opp.Stage,
      ACV: opp.ACV,
      Projected_Close_Date: opp.Projected_Close_Date,
      Forecast_Category: opp.Forecast_Category,
      Forecast_Category_Name: opp.Forecast_Category_Name,
      ...(isManager && {
        Manager_Override_ACV: opp.Manager_Override_ACV,
        Manager_Override_Forecast_Category: opp.Manager_Override_Forecast_Category,
      }),
    })),
  };



  props.submitForecast(submissionData);
};
  const handleJudgementChange = (category, value) => {
    setState((prev) => ({
      ...prev,
      judgementValues: {
        ...prev.judgementValues,
        [category]: parseFloat(value) || 0,
      },
    }));
  };

  const handleOppForecastCategoryChange = (oppId, newCategory, newCategoryName) => {
    setState((prev) => ({
      ...prev,
      opportunities: prev.opportunities.map((opp) =>
        opp.Opp_ID === oppId
          ? { ...opp, Forecast_Category: newCategory, Forecast_Category_Name: newCategoryName }
          : opp
      ),
    }));
  };

  const handleManagerOverrideChange = (oppId, field, value) => {
    setState((prev) => ({
      ...prev,
      opportunities: prev.opportunities.map((opp) =>
        opp.Opp_ID === oppId
          ? { ...opp, [field]: value }
          : opp
      ),
    }));
  };

 const calculateTotals = () => {
  if (!Array.isArray(state.opportunities) || state.opportunities.length === 0) {
    const emptyTotals = {};
    if (props.forecastRollupData?.includeForForecastRollup) {
      props.forecastRollupData.includeForForecastRollup.forEach((category) => {
        emptyTotals[category] = 0;
      });
    }
    return { repTotals: emptyTotals, managerTotals: emptyTotals };
  }

  const repTotals = {};
  const managerTotals = {};
  const repTotalsWithoutJudgement = {}

  if (props.forecastRollupData?.includeForForecastRollup) {
    props.forecastRollupData.includeForForecastRollup.forEach((categoryName) => {
      // REP TOTALS - Always use original values (no overrides)
      const repOppTotal = state.opportunities
        .filter((opp) => opp.Forecast_Category_Name === categoryName)
        .reduce((sum, opp) => sum + (parseFloat(opp.ACV) || 0), 0);
      
      const repJudgementValue = parseFloat(state.judgementValues[categoryName]) || 0;
      repTotals[categoryName] = isManager ? repOppTotal : repOppTotal;

      // MANAGER TOTALS - Use override values if available
      if (isManager) {
        const managerCategoryTotal = state.opportunities.reduce((sum, opp) => {
          // Determine which category to count this opp under
          const oppCategory = opp.Manager_Override_Forecast_Category && 
                             opp.Manager_Override_Forecast_Category !== "-"
            ? opp.Manager_Override_Forecast_Category
            : opp.Forecast_Category_Name;

          // Only include if this opp belongs to the current category
          if (oppCategory === categoryName) {
            // Use override ACV if available, otherwise use original ACV
            const acv = opp.Manager_Override_ACV && opp.Manager_Override_ACV !== ""
              ? parseFloat(opp.Manager_Override_ACV)
              : parseFloat(opp.ACV) || 0;
            return sum + acv;
          }
          return sum;
        }, 0);

        const managerJudgementValue = parseFloat(state.judgementValues[categoryName]) || 0;
        managerTotals[categoryName] = managerCategoryTotal ;
      } else {
        // For reps, manager totals same as rep totals
        managerTotals[categoryName] = repTotals[categoryName];
      }
    });
  }

  return { repTotals, managerTotals };
};

  const { repTotals, managerTotals } = calculateTotals();
  const isSubmitDisabled = !hasAnyChanges() || props.submittingForecast || hasSubmittedSuccessfully;

  return (
    <Grid container className={classes.root}>
      <AddHeaderDescriptionWithHelperText
        header="Forecast Roll Up"
        description="Review and submit your weekly forecasts."
        helperTextCharts={props.helperTextCharts}
      />

      {props.forecastRollupData && props.forecastRollupData.opportunities ? (
        <>
          {/* Header Section */}
          <Grid item xs={12} className={classes.section}>
            <ForecastRollupHeader
              repName={props.forecastRollupData.name}
              weekEnding={props.forecastRollupData.week_ending?.[0]}
              role={props.forecastRollupData.role}
              repTotals={repTotals}
             managerTotals={managerTotals}
              currencySymbol={props.Currency_Symbol}
              includeForForecastRollup={props.forecastRollupData.includeForForecastRollup}
              opportunities={state.opportunities}
              columns={props.forecastRollupData.columns}
              valueLabel={props.Value_Label}
              onForecastCategoryChange={handleOppForecastCategoryChange}
              forecastCategories={props.forecastRollupData.forecastCategories}
              judgementValues={state.judgementValues}
              judgementRepValues={props.forecastRollupData.judgementRepValues}
              onJudgementChange={handleJudgementChange}
              isManager={isManager}
              onManagerOverrideChange={handleManagerOverrideChange}
              team={props.forecastRollupData.team}
              wonData={props.forecastRollupData.wonData}
              quotaData={props.forecastRollupData.quotaData}
              teamQuota={props.forecastRollupData.teamQuota}
              currentFiscalQuarter={props.forecastRollupData.currentFiscalQuarter}
              repsSummary={props.forecastRollupData.repsSummary}
            />
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} className={classes.centerButton}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleOpenConfirmModal}
              disabled={isSubmitDisabled}
              data-test="submit-forecast"
            >
              {props.submittingForecast ? "Submitting..." : hasSubmittedSuccessfully ? "Submitted" : "Submit Forecast"}
            </Button>
          </Grid>

          {/* Confirmation Modal */}
          <Dialog
            open={confirmModalOpen}
            onClose={handleCloseConfirmModal}
            aria-labelledby="confirm-dialog-title"
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle id="confirm-dialog-title" className={classes.dialogTitle}>
              Confirm Forecast Submission
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <DialogContentText>
                This will submit your forecast for the week ending{" "}
                <strong>{formatWeekEndingDate(props.forecastRollupData?.week_ending?.[0])}</strong>.
              </DialogContentText>
              <DialogContentText style={{ marginTop: "1rem" }}>
                Are you sure you want to proceed?
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button
                onClick={handleCloseConfirmModal}
                color="default"
                variant="outlined"
                className={classes.cancelButton}
                data-test="cancel-submit"
              >
                No
              </Button>
              <Button
                onClick={handleConfirmSubmit}
                color="primary"
                variant="contained"
                autoFocus
                data-test="confirm-submit"
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <Grid item xs={12} className={classes.section}>
          <Card
            elevation={2}
            style={{
              width: "100%",
              padding: "1.5rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <Skeleton
              variant="rect"
              animation="wave"
              width="100%"
              height={350}
              style={{
                borderRadius: "8px",
                backgroundColor: "rgba(0,0,0,0.08)",
              }}
            />
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

function mapStateToProps(state) {
  const { forecastRollupData, user, submittingForecast, submitSuccess } = state.app;
  return {
    forecastRollupData,
    company: user.company,
    userId: user.userId,
    Value_Label: user.Value_Label,
    Currency_Symbol: user.Currency,
    submittingForecast,
    submitSuccess,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
}

const mapDispatchToProps = (dispatch) => ({
  getForecastRollupData: (company) => {
    dispatch({ type: "get_forecast_rollup_data_request" });
    appService.getForecastRollupData().then(
      (json) => dispatch({ type: "get_forecast_rollup_data_success", json }),
      (error) => {
        const errMsg = typeof error === "object" ? "Something went wrong" : error;
        dispatch({ type: "get_forecast_rollup_data_failure", error: errMsg });
      }
    );
  },
  submitForecast: (submissionData) => {
    dispatch({ type: "submit_forecast_request" });
    appService.submitForecast(submissionData).then(
      (json) => {
        dispatch({ type: "submit_forecast_success", json });
        dispatch({
          type: "show_alert",
          message: "Forecast submitted successfully!",
          severity: "success",
        });
        // ✅ Call getForecastRollupData after successful submission
        dispatch({ type: "get_forecast_rollup_data_request" });
        appService.getForecastRollupData().then(
          (json) => dispatch({ type: "get_forecast_rollup_data_success", json }),
          (error) => {
            const errMsg = typeof error === "object" ? "Something went wrong" : error;
            dispatch({ type: "get_forecast_rollup_data_failure", error: errMsg });
          }
        );
      },
      (error) => {
        const errMsg = typeof error === "object" ? "Something went wrong" : error;
        dispatch({ type: "submit_forecast_failure", error: errMsg });
        dispatch({
          type: "show_alert",
          message: "Failed to submit forecast. Please try again.",
          severity: "error",
        });
      }
    );
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(ForecastRollup);